import { useQuery } from '@tanstack/react-query'
import React from 'react'

import { type BrandAccount } from './useMainQuery'
import { useMainQueryKey } from './useMainQueryKey'

export const useMainQueryBrandAccounts = () => {
  const queryKey = useMainQueryKey()
  const { data } = useQuery<BrandAccount[]>({ enabled: false, queryKey })

  return React.useMemo(() => data ?? [], [data])
}
